import { render, staticRenderFns } from "./DocumentTypes.vue?vue&type=template&id=30670b8b"
import script from "./DocumentTypes.vue?vue&type=script&lang=js"
export * from "./DocumentTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports